import {
  IStatus_Created,
  IStatus_Started,
  IStatus_Error,
  IStatus_Timeout,
  IStatus_Complete,
} from '../types/utils'

/*

  core

*/
export const STRIPE_API_VERSION = '2020-08-27'
export const ACCESS_TOKEN_QUERY_PARAM = 'access_token'
export const ACCESS_TOKEN_ROUTE_PARAM = 'access_token'
export const API_URL = '/api/v1'

export const SYSTEM_USER_EMAIL = 'kai@kaidam.ltd'


/*

  secrets

*/
export const SECRET_SLACK_TOKEN = 'SLACK_TOKEN'

/*

  general state

*/

export const STATUS_CREATED: IStatus_Created = 'created'
export const STATUS_STARTED: IStatus_Started = 'started'
export const STATUS_ERROR: IStatus_Error = 'error'
export const STATUS_TIMEOUT: IStatus_Timeout = 'timeout'
export const STATUS_COMPLETE: IStatus_Complete = 'complete'

/*

  admin users

*/

export const ADMIN_USERS = [
  'kai@kaidam.ltd',
  'adam@kaidam.ltd',
]